import { FC } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import {
  SKELETON_FOREGROUND_COLOR,
  SKELETON_MAIN_COLOR,
  SKELETON_SPEED,
  SKELETON_STYLES,
} from '@shared/consts/skeleton'
import ContentLoader from '@shared/lib/components/SkeletonContentLoader'

const Skeleton: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>> = () => {
  return (
    <BlockBoundary>
      <ContentLoader
        speed={SKELETON_SPEED}
        backgroundColor={SKELETON_MAIN_COLOR}
        foregroundColor={SKELETON_FOREGROUND_COLOR}
        style={SKELETON_STYLES}
        width={'150px'}
        height={'18px'}>
        <rect height='18px' width='150px' rx='8' ry='7' />
      </ContentLoader>
    </BlockBoundary>
  )
}

export default Skeleton
